import axios from 'axios';
import React, { useEffect, useState } from 'react';
import { FaqApi } from '../../api';
import { isAuthenticated } from '../../api-handle/authService';
import Context from './index';

const EmailProvider = (props) => {
    const [faq, setFaq] = useState([]);

    const fetchFaq = async () => {
        if (!isAuthenticated()) return;
        try {
            await axios.get(`${FaqApi}`).then((resp) => {
                setFaq(resp.data);
            });
        } catch (error) {
            //'error', error);
        }
    };

    useEffect(() => {
        fetchFaq();
    }, [setFaq]);

    return (
        <Context.Provider
            value={{
                ...props,
                faq
            }}
        >
            {props.children}
        </Context.Provider>
    );
};

export default EmailProvider;
